export const ERROR_MESSAGE = {
  CHARGE_IS_INVALIDATE: '금액은 1000원 이상 100000원 미만이어야합니다. 금액을 다시 입력해주세요.',
  WIN_NUMBER_IS_INVALIDATE:
    '당첨 번호는 1~45 사이의 숫자이며, 중복이 포함될 수 없습니다. 다시 입력해주세요',
};

export const CONFIRM_MESSAGE = {
  CREATE_LOTTO_LIST: '구매하신 로또는 사라집니다. 그래도 구매하시겠습니까?',
};
